import { Button, Row, Table } from "antd";
import Title from "antd/es/typography/Title";
import { buttonStyle, fullWidthStyle, titleStyle } from "../constants/style";
import { ColumnType } from "antd/es/table";
import useContextMenu from "../hooks/use-context-menu";

type SizeLevel = 1 | 2 | 3 | 4 | 5;
type Props<DataType> = {
  title?: string,
  columns: ColumnType<DataType>[],
  rows: DataType[],
  loading?: boolean,
  disablePagination?: boolean,
  disableActionButton?: boolean,
  actionLabel?: string,
  titleSizeLevel?: SizeLevel,
  onAction?: boolean | (() => void),
  onSelect?: (r: DataType) => void,
  onContextMenu?: (r: DataType) => string[],
  onContextMenuOptionSelected?: (r: DataType, option: string) => void
};

export default function <DataType>(p: Props<DataType>) {
  const canAction = !(!p.onAction);
  const disableAction = p.disableActionButton ?? (!canAction || p.loading === true);
  const onAction = typeof p.onAction === "function" ? p.onAction as Function : undefined;
  const { open, overlay } = useContextMenu<DataType>(p.onContextMenuOptionSelected);

  return (
    <div
      style={fullWidthStyle}>
      <Row justify="space-between">
        {
          !p.title ? undefined :
            <Title style={titleStyle} level={p.titleSizeLevel ?? 3}>{p.title}</Title>
        }
        <div>
          {
            !canAction ? undefined :
              <Button type="primary" style={buttonStyle} disabled={disableAction} onClick={() => onAction?.()}>{p.actionLabel ?? "Create"}</Button>
          }
        </div>
      </Row>
      <div style={{ position: "relative" }}>
        <Table
          size="small"
          loading={p.loading ?? false}
          columns={p.columns}
          dataSource={p.rows}
          pagination={p.disablePagination ? false : undefined}
          onRow={r => ({
            onClick: !p.onSelect ? undefined : () => p.onSelect!(r),
            onContextMenu: !p.onContextMenu ? undefined : (mouseEvent) => {
              // Don't show the normal context menu.
              mouseEvent.preventDefault();

              // Get options for the record.
              // If there are none, don't show the menu.
              const options = p.onContextMenu!(r);
              if (!options) {
                return;
              }

              open(mouseEvent, r, options);
            }
          })}
        />
        {overlay}
      </div>
    </div >
  );
}